

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AnimationWrapper from './animationWrapper.js';
import {FaRegWindowClose} from 'react-icons/fa';
import Moment from 'moment';

class ReceiptModalComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    triggerCallback = (receivedType) => {
            this.props.callback({
                type: receivedType,
                uniqueModalReferenceId: this.props.uniqueModalReferenceId
            })
    }

    closeLinkClicked(){

    }

    render() {
        return (
            <div>
                {this.props.isVisible ? <div className="commonPopupFormBackDrop animated fadeIn"></div> : null}
                <AnimationWrapper.cssTransition isVisible={this.props.isVisible}>
                    <div ref={this.props.uniqueModalReferenceId} id="rechargeReceiptDiv"  className="commonPopupOuterMostContainer">
                        <div style={{marginLeft:'auto',marginRight:'auto', flex: this.props.rightPartFlexValue,backgroundColor:this.props.contentPartBackgroundColor }}>
                            <div className="receiptContentDiv m-5">
                                <FaRegWindowClose className="closeIcon" onClick={() => this.triggerCallback("cancel")}/>
                                <div className="receiptDetailsPart mx-auto col-md-12 px-3">
                                    <div className="mainHeading col-md-12 row justify-content-center pt-2 pb-4">{this.props.content}</div>
                                    <div className="col-md-12 row pb-2">
                                        <div className="col-md-6 detailLabel">{this.props.locales.transactionIdInBillPaymentPart}</div>
                                        <div className="col-md-6 detailVal">{this.props.transactionId}</div>
                                    </div>
                                    <div className="col-md-12 row pb-2">
                                        <div className="col-md-6 detailLabel">{this.props.locales.dateAndTimeInReceiptModal}</div>
                                        <div className="col-md-6 detailVal">{Moment().format("MM/DD/YYYY")}</div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-6 detailLabel">{this.props.locales.serviceIdInReceiptModal}</div>
                                        <div className="col-md-6 detailVal">{this.props.serviceId}</div>
                                    </div>
                                    <div className="col-md-12 separationDiv row mt-4 mb-3">
                                   
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-6 detailLabel" style={{fontWeight:600}}>{this.props.locales.amountPaidInReceiptModal}</div>
                                        <div className="col-md-6 detailVal">${this.props.finalRechargeAmount}</div>
                                    </div>
                                    <div className="col-md-12 separationDiv row mt-3 mb-4">
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                </AnimationWrapper.cssTransition>
            </div>
        );
    }
}

ReceiptModalComponent.defaultProps = {
    isVisible: false,
    isCancelButtonVisible: true,
    isResetButtonVisible: true,
    isSubmitButtonVisible: true,
    cancelButtonText: "cancel",
    resetButtonText: "reset",
    submitButtonText: "submit",
    children: ">>noChildrensToShow",
    mainHeading: ">>emptyMainHeading",
    uniqueModalReferenceId: "NA",
    leftPartFlexValue: 1,
    rightPartFlexValue: 8
}

ReceiptModalComponent.propTypes = {
    isVisible: PropTypes.bool,
    isCancelButtonVisible: PropTypes.bool,
    isResetButtonVisible: PropTypes.bool,
    isSubmitButtonVisible: PropTypes.bool,
    cancelButtonText: PropTypes.string,
    resetButtonText: PropTypes.string,
    submitButtonText: PropTypes.string,
    mainHeading: PropTypes.string,
    callback: PropTypes.func,
    uniqueModalReferenceId: PropTypes.string,
    leftPartFlexValue: PropTypes.number,
    rightPartFlexValue: PropTypes.number
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales
    }
}

const ReceiptModalComponentContainer = connect(
    mapStateToProps
)(ReceiptModalComponent)

export default ReceiptModalComponentContainer;
